/** Single portal target ID for the docked side panel content region. */
export const DOCKED_SIDE_PANEL_CONTENT_ID = 'docked-side-panel-content'
